export default {
  oneTime: {
    en: 'One-time purchase',
  },
  giftWithSpendThresholdFetching: {
    en: 'Gift with purchase',
  },
  giftWithSpendThreshold: {
    en: 'Gift with purchase<br />over {price}',
  },
  varietyProductName: {
    en: '{name} with {variety} Scent',
  },
}
